import { ChangelogVersion } from '@infodata-group/inf-commons';
import { ChangelogStatutTypes } from '../type/changelog-statut.types';
import dayjs from 'dayjs';
import { WebtoolsChangelogEntry } from './webtools-changelog-entry';
import { DtoChangelogVersionInterface } from '../interface/dto-webtools-changelog-version.interface';

export class WebtoolsChangelogVersion extends ChangelogVersion {
  public createdBy: string;
  public updatedBy: string;
  public updatedAt: Date;
  public createdAt: Date;
  public product: string;
  public status: ChangelogStatutTypes;

  public get statusLabel(): string {
    switch (this.status) {
      case 'P':
        return 'Publié';
      case 'D':
        return 'Brouillon';
      default:
        return '-';
    }
  }

  constructor(id: string, date: Date, title: string) {
    super(id, date, title);
  }

  public override toTitle(): string {
    return this.title;
  }

  public toSubtitle(): string {
    let dateToUse: Date;
    let authorToUse = '';

    if (this.updatedAt) {
      dateToUse = new Date(this.updatedAt);
      authorToUse = this.updatedBy;
    } else if (this.date) {
      dateToUse = new Date(this.date);
      authorToUse = this.createdBy;
    } else {
      dateToUse = new Date(this.createdAt);
      authorToUse = this.createdBy;
    }
    return `${dayjs(dateToUse).format('DD/MM/YYYY - HH:mm')} (${authorToUse})`;
  }

  public override serialize(): DtoChangelogVersionInterface {
    return {
      id: this.getId(),
      date: this.date ? dayjs(this.date).format('DD/MM/YYYY') : null,
      product: this.product,
      title: this.title,
      entries: this.entries.map((e: WebtoolsChangelogEntry) => e.serialize()),
      updatedAt: this.updatedAt
        ? dayjs(this.updatedAt).format('DD/MM/YYYY - HH:mm')
        : null,
      updatedBy: this.updatedBy,
      createdAt: this.createdAt
        ? dayjs(this.createdAt).format('DD/MM/YYYY - HH:mm')
        : null,
      createdBy: this.createdBy,
      status: this.status,
    };
  }
}
